import React from 'react';

import css from './DotsLoader.module.scss';

const DotsLoader = () => {
  return (
    <>
      <div className={css.dot1} />
      <div className={css.dot2} />
      <div className={css.dot3} />
    </>
  );
};

export default DotsLoader;
